module.exports = __webpack_public_path__ + "img/mongo.c00129be.png";